import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withTheme } from 'styled-components';
import { withTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import Icon from '../../../styleguide/Icon';

import {
  customStyles,
  StyledModal,
  StyledClose,
  StyledHeader,
  StyledTitle,
  StyledContent,
} from '../_styles';

import { mapDispatchToProps, mapStateToProps } from '../_shared.js';

Modal.setAppElement('#root');

const PageModal = ({
  theme,
  closeModal,
  children,
  title,
  width,
  isOpen = false,
  forceIsOpen = false,
  showCloseButton = true,
  showHeader = true,
}) => {
  customStyles.overlay.zIndex = _.get(theme, 'zIndex.modal', 999);
  return (
    <StyledModal
      isOpen={isOpen || forceIsOpen}
      contentLabel="Modal"
      width={width}
      style={customStyles}
      shouldCloseOnOverlayClick={true}
      onAfterOpen={() => {
        disableBodyScroll(document.body);
      }}
      onAfterClose={() => {
        enableBodyScroll(document.body);
      }}
      onRequestClose={() => {
        closeModal();
      }}
    >
      {showHeader ? (
        <StyledHeader>
          <StyledTitle>{title}</StyledTitle>
          {showCloseButton ? (
            <StyledClose
              href="#"
              onClick={(e) => {
                e.preventDefault();
                closeModal();
              }}
            >
              <Icon className="nc-bold-remove" />
            </StyledClose>
          ) : null}
        </StyledHeader>
      ) : null}

      <StyledContent>{children}</StyledContent>
    </StyledModal>
  );
};

const PageModalConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(PageModal);

export default withTranslation()(withTheme(PageModalConnected));
